import { gql } from '@apollo/client';
import { idStatusTypes, termsStatusTypes } from '../constants/statusConstants';

export const APPLICATION_MANAGER_QUERY = gql`
  query UserManagement($propertyId: String!) {
    property(id: $propertyId) {
      id
      street
      isBusinessVerificationLiteEligible
    }
    user {
      features {
        canAccessBusinessVerificationLite
      }
      userManagementCompany {
        id
        employees {
          id
          role
          contactInfo {
            firstName
            lastName
            email
          }
          idVerification {
            status
          }
          termSet {
            status
          }
        }
      }
    }
  }
`;

export const BECOME_APPLICATION_MANAGER_MUTATION = gql`
  mutation BecomeApplicationManager($firstName: String!, $lastName: String!) {
    becomeApplicationManager(firstName: $firstName, lastName: $lastName) {
      id
      role
      contactInfo {
        firstName
        lastName
        email
      }
    }
  }
`;

export function getNeedsApplicationManager(data) {
  if (!data) {
    return false;
  }
  if (!(data?.property?.isBusinessVerificationLiteEligible ?? false)) {
    return false;
  }
  if (data.user.userManagementCompany === null) {
    return false;
  }
  if (!data.user.features.canAccessBusinessVerificationLite) {
    return false;
  }

  const { employees } = data.user.userManagementCompany;
  return !employees.some((employee) => employee.role === 'applicationManager');
}

export function getApplicationManagerNeedsToIdVerify(data, userToken) {
  if (!data) {
    return false;
  }
  if (!(data?.property?.isBusinessVerificationLiteEligible ?? false)) {
    return false;
  }
  if (data.user.userManagementCompany === null) {
    return false;
  }
  if (getNeedsApplicationManager(data)) {
    return false;
  }
  if (!data.user.features.canAccessBusinessVerificationLite) {
    return false;
  }
  const applicationManager = data.user.userManagementCompany.employees.find(
    (employee) => employee.role === 'applicationManager',
  );
  if (applicationManager.id === userToken) {
    return false;
  }
  return (
    applicationManager.idVerification.status !== idStatusTypes.CURRENTLY_IDENTIFIED ||
    applicationManager.termSet.status !== termsStatusTypes.TAC_CURRENTLY_ACCEPTED
  );
}

export function getIsCurrentUserAnAdmin(data, userIdIrene) {
  if (!data?.user?.userManagementCompany?.employees) {
    return false;
  }
  const { role } = data.user.userManagementCompany.employees.find((employee) => employee.id === userIdIrene);
  return role === 'admin' || role === 'applicationManager';
}

export function getIsCurrentUserAnApplicationManager(data, userIdIrene) {
  if (!data?.user?.userManagementCompany?.employees) {
    return false;
  }
  const { role } = data.user.userManagementCompany.employees.find((employee) => employee.id === userIdIrene);
  return role === 'applicationManager';
}

export function getAdmins(data) {
  if (!data?.user?.userManagementCompany?.employees) {
    return [];
  }
  return data.user.userManagementCompany.employees.filter((employee) => employee.role === 'admin');
}

export function getIsOnlyAdmin(employees) {
  return (
    employees.filter((employee) => employee.role === 'admin' || employee.role === 'applicationManager').length === 1
  );
}
